var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ICON_CLASSIC_SVG, ICON_SMART_SVG, ICON_SMART_BLUE_SVG, ICON_CLASSIC_BLUE_SVG } from "../../assets";
import { ThemeContextConsumer } from "../../context/theme";
var SmartClassicSelector = /** @class */ (function (_super) {
    __extends(SmartClassicSelector, _super);
    function SmartClassicSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    SmartClassicSelector.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeContextConsumer, null, function (theme) {
            return React.createElement("div", { className: (_this.props.className || ' ') + 'classic-smart-view', style: {} },
                React.createElement("a", { href: "javascript:void(0)", onClick: function () {
                        if (_this.props.selected == 'classic') {
                            _this.props.onChanged('smart');
                        }
                    } },
                    React.createElement("img", { src: (theme == 'black' && _this.props.selected == 'smart') ? ICON_SMART_BLUE_SVG : ICON_SMART_SVG, height: 18, style: _this.props.selected == 'classic' ? UnselectedStyle : {} })),
                React.createElement("a", { href: "javascript:void(0)", onClick: function () {
                        if (_this.props.selected == 'smart') {
                            _this.props.onChanged('classic');
                        }
                    } },
                    React.createElement("img", { src: (theme == 'black' && _this.props.selected == 'classic') ? ICON_CLASSIC_BLUE_SVG : ICON_CLASSIC_SVG, height: 18, style: Object.assign({}, { marginLeft: '12px' }, _this.props.selected == 'smart' ? UnselectedStyle : {}) })));
        }));
    };
    return SmartClassicSelector;
}(React.PureComponent));
export default SmartClassicSelector;
var UnselectedStyle = {
    opacity: 0.5
};
//# sourceMappingURL=SmartClassicSelector.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/selector/SmartClassicSelector.js
// module id = 473
// module chunks = 0